<template>
    <div class="t-work-area__row">
        <div class="t-work-area__column_small">
            <cmp-lesson class="t-work-area__cell"></cmp-lesson>

            <cmp-teacher v-if="!course.belonging"></cmp-teacher>

            <button class="t-btn_invite t-btn t-btn_white t-btn_full" @click.prevent="modalDialogType_inviteOpen()"
                    v-if="!blackList && hasAuth">
					<span>
						{{ pageText.inviteBtn }}
						<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M8 1C8 0.447715 7.55228 0 7 0C6.44772 0 6 0.447715 6 1V6H1C0.447715 6 0 6.44772 0 7C0 7.55228 0.447715 8 1 8H6V13C6 13.5523 6.44772 14 7 14C7.55228 14 8 13.5523 8 13V8H13C13.5523 8 14 7.55228 14 7C14 6.44772 13.5523 6 13 6H8V1Z"
                                  fill="#52A8F2"/>
						</svg>
					</span>
            </button>
        </div>
        <div class="t-work-area__column_big">
            <div class="t-work-area__cell">
                <h2 class="_blue">{{ pageText.title_1 }}</h2>
                <div class="t-input t-course-description" v-html="course.text"></div>
                <div class="t-course-video" v-if="video_type === 'youtube'">
                    <iframe :src="'https://www.youtube.com/embed/' + video + '?rel=0&amp;controls=1&amp;showinfo=0'"
                            frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                </div>
                <div class="t-course-video" v-if="video_type === 'vimeo'">
                    <iframe :src="'https://player.vimeo.com/video/' + video + ''"
                            frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                </div>
                <div class="t-input">
                    <label>{{ pageText.title_3 }}</label>
                    <p>
                        <template v-for="(item, index) in course.topics">
                            {{ item.label }}<template v-if="(index + 1) < course.topics.length">, </template>
                        </template>
                    </p>
                </div>
                <template v-if="course.type === 3">
                    <h2 class="_blue">{{ pageText.title_4 }}<span>{{ course.lessons.length  + ' ' + declOfNum(course.lessons.length, pageText.lessonsCount) }}</span>
                    </h2>
                    <div class="t-lessonDescription" v-for="(item, index) in course.lessons">
                        <h2 class="_blue">{{ (index + 1) }} {{ pageText.lesson }} - {{item.lessonName}}</h2>
                        <p>
                            <b>{{ ConvertDuration(item.duration) }}</b>
                            {{ item.text }}
                        </p>
                    </div>
                </template>
                <template v-if="!blackList">
                    <h2 class="_blue">{{ pageText.schedule }} <span
                            v-if="!course.belonging">{{ pageText.scheduleHint }}</span></h2>
                    <cmp-calendar></cmp-calendar>
                </template>
            </div>
            <cmp-reviews v-if="reviews.items.length"></cmp-reviews>
            <!-- <cmp-comments v-if="(comments.items.length || hasAuth) && !blackList"></cmp-comments> -->
        </div>
    </div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/courseDetail.json' : 'staticText',
        main: {
            title_1: "Описание",
            title_3: "Темы",
            title_4: "Программа курса",
            inviteBtn: "Пригласи друга",
            lessonsCount: ["занятие", "занятия", "занятий"],
            lesson: "урок",
            schedule: "Расписание",
            scheduleHint: "Выберите из доступных дней для записи",
            hours: ["час", "часа", "часов"],
            minute: ["минута", "минуты", "минут"]
        }
    };

    import {store} from '../../../store/index'

    import {mapActions, mapGetters} from 'vuex';

    import Calendar from '../../../vue_components/Calendar/Calendar.vue'
    import Teacher from '../../../vue_components/Teacher_small.vue'
    import Lesson from '../../../vue_components/Lesson.vue'
    import Comments from '../../../vue_components/Comments/Index.vue'
    import ReviewList from '../../../vue_components/Courses/ReviewList.vue'

    export default {
        components: {
            'cmp-calendar': Calendar,
            'cmp-teacher': Teacher,
            'cmp-lesson': Lesson,
            'cmp-comments': Comments,
            'cmp-reviews': ReviewList,
        },
        data() {
            return {
                video: '',
                pageText: {}
            }
        },
        computed: {
            ...mapGetters('coursesList', ['course', 'comments', 'reviews']),
            ...mapGetters('profile', ['hasAuth']),
            ...mapGetters('calendar', ['date_active', 'calendarTypeValue', 'day_week_header']),
            video_type() {
                let type = '';

                if (this.course.video !== null) {
                    if (this.course.video.indexOf('youtube') >= 0 || this.course.video.indexOf('youtu.be') >= 0) {
                        this.video = this.course.video.split('?v=')[1];
                        if (!this.video){
                            this.video = this.course.video.split('youtu.be/')[1];
                        }
                        this.video = this.video.split('&')[0];
                        type = 'youtube';
                    }
                    if (this.course.video.indexOf('vimeo') >= 0) {
                        let index = this.course.video.lastIndexOf('/') + 1;
                        this.video = this.course.video.substring(index, this.course.video.length);
                        type = 'vimeo';
                    }
                }
                

                return type
            },
            blackList() {
                if (!this.course.belonging)
                    return this.course.teacher.blackList;
                else
                    return false
            }
        },
        watch: {
            calendarTypeValue() {
                let start, end;

                if (this.calendarTypeValue.value === 1) {
                    start = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.1';
                    end = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.date_active.daysInMonth();
                } else {
                    let m = this.day_week_header[0].value;
                    let s = this.day_week_header[this.day_week_header.length - 1].value;

                    start = m.getFullYear() + '.' + (m.getMonth() + 1) + '.' + m.getDate();
                    end = s.getFullYear() + '.' + (s.getMonth() + 1) + '.' + s.getDate();
                }

                this.LoadStreams({start: start, end: end, id: this.course.id});
            },
            date_active() {
                let start, end;

                if (this.calendarTypeValue.value === 1) {
                    start = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.1';
                    end = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.date_active.daysInMonth();
                } else {
                    let m = this.day_week_header[0].value;
                    let s = this.day_week_header[this.day_week_header.length - 1].value;

                    start = m.getFullYear() + '.' + (m.getMonth() + 1) + '.' + m.getDate();
                    end = s.getFullYear() + '.' + (s.getMonth() + 1) + '.' + s.getDate();
                }

                this.LoadStreams({start: start, end: end, id: this.course.id});
            }
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            ...mapActions('coursesList', ['LoadStreams']),
            ...mapActions('modal', ['modalDialogType_inviteOpen']),
            ...mapActions('calendar', ['GoTo']),
            declOfNum(n, titles) {
                if (titles)
                    return titles[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2];

                return ''
            },
            ConvertDuration(e) {
                let hours = Math.floor(e / 60);
                let minutes = e - hours * 60;

                hours = hours > 0 ? hours + ' ' + this.declOfNum(hours, this.pageText.hours) : '';
                minutes = minutes > 0 ? minutes + ' ' + this.declOfNum(minutes, this.pageText.minute) : '';

                return hours + ' ' + minutes;
            },
            Load(pageText) {
                this.pageText = pageText;
                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            }
        },
        beforeRouteLeave(to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
        beforeRouteUpdate(to, from, next) {
            // store.dispatch('coursesList/LoadComments', {id: to.id, page: to.query.page}).then(() => {
            //     next()
            // });
            store.dispatch('coursesList/LoadReviews', {id: to.params.id, page: to.query.page}).then(() => {
                next()
            });
        },
        beforeRouteEnter(to, from, next) {
            let date = new Date();
            if (store.getters['coursesList/course'].nextLesson.date_time){
                date = new Date(store.getters['coursesList/course'].nextLesson.date_time);
            }

            let start = date.getFullYear() + '.' + (date.getMonth() + 1) + '.1';
            let end = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.daysInMonth();

            let count = 0;

            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;
                count++;
                RunNext();
            });
            store.dispatch('staticText/LoadCommentsText').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('staticText/LoadBalanceText').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('calendar/LoadCalendarText').then(() => {
                count++;
                RunNext();
            });
            // store.dispatch('coursesList/LoadComments', {id: to.params.id, page: to.query.page}).then(() => {
            //     count++;
            //     RunNext();
            // });
            store.dispatch('coursesList/LoadStreams', {start: start, end: end, id: to.params.id}).then(() => {
                count++;
                RunNext();
            });
            store.dispatch('staticText/LoadReviewText').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadReviews', {id: to.params.id}).then(() => {
                count++;
                RunNext();
            });
            if (store.getters['profile/hasAuth']) {
                store.dispatch('profile/LoadBalance').then(() => {
                    count++;
                    RunNext();
                });
            } else {
                count++;
            } 
            let RunNext = () => {
                if (count > 7){
                    next(vm => {
                        vm.Load(pageText)
                        vm.GoTo(date);
                    })
                }
            }
        }
    }
</script>

<style lang="sass">
    .t-course-description
        white-space: pre-line
    .t-course-video
        margin: 0 0 32px
        border-radius: 16px
        overflow: hidden
        width: 820px
        height: 470px
        max-width: 100%
        iframe
            width: 100%
            height: 100%
    .t-lessonDescription
        margin: 0 0 16px
        p
            line-height: 1.2
        b
            display: block
            margin-bottom: 8px
</style>



// WEBPACK FOOTER //
// src/vue_pages/Courses/View/View.vue